module.exports = import("/eop-ui/remoteEntry.js");